import axios from 'axios';
import { getIntendType, crossSiteCheckUrl } from '../components/common/Helpers/index';
import { getChannelId } from './HttpService';
import { getSecureBaseUrl } from './UrlMapperService';
import { apiUrls } from '../constants/apiUrl';

export const FE_API_ERROR = 'FE_API_ERROR';
export const FE_API_JS_ERROR = 'FE_API_JS_ERROR';
export const FE_JS_ERROR = 'FE_JS_ERROR';

export const logError = (methodName, errorObj, issueType) => {
  // const enableError = getSession('enableErrorLog');
  const errorLog = errorObj?.length > 0 ? errorObj[0] : errorObj;
  const eventType = 'FE_ERROR';
  const pageName = window.location.pathname
    .split('/')
    .pop()
    .split('.')[0];
  const data = {
    messageType: issueType,
    eventType,
    errorMessage: errorLog?.message || '',
    pageUrl: window.location.href,
    loggerMessage: {
      message: errorLog?.message || '',
      loglevel: 'loglevel',
      id: errorLog?.debugId || '',
      userAgent: navigator.userAgent,
      pageTitle: pageName,
      host: window.location.host,
      stackTrace: errorLog || {},
      componentStack: methodName,
    },
  };
  //------
  const postUrl = crossSiteCheckUrl(`${getSecureBaseUrl()}${apiUrls().errorLogUrl}`);
  const xhr = new XMLHttpRequest();
  xhr.open('POST', postUrl);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.setRequestHeader('Accept', 'application/json');
  xhr.setRequestHeader('channelId', getChannelId());
  xhr.setRequestHeader('flowName', `${getIntendType()}`);
  xhr.send(JSON.stringify(data));

  // if (enableError) {
  // api(`${getSecureBaseUrl()}` + apiUrls().errorLogUrl, 'POST', data).catch((error) => {
  // });
  // }
};

export const api = (url, method, data) =>
  axios.request({
    method,
    url,
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  });

export const getErrorLogObj = (errObj) => {
  if (errObj) {
    return {
      json: errObj.json ? errObj : true,
      eventType: errObj.eventType ? errObj.eventType : 'FeError',
      message: errObj.message ? errObj.message : 'Looks like something went wrong. Please try again later.',
      messageType: errObj.messageType ? errObj.messageType : 'ERROR',
      errorCategory: errObj.errorCategory ? errObj.errorCategory : 'API-ERROR',
      note: errObj.note,
      serviceUrl: errObj.serviceUrl,
      networkError: errObj.networkError,
    };
  }
  console.log('Error Object is null');
};
